import { ShipmentSummary } from '~api/som_search';

type ShipmentAction =
  | 'BOOK'
  | 'SCHEDULE_PICKUP'
  | 'CANCEL'
  | 'CANCEL_AND_DUPLICATE'
  | 'CREATE_RETURN'
  | 'DUPLICATE'
  | 'EDIT'
  | 'FREIGHT_DOCUMENTS'
  | 'PRINT_LABEL'
  | 'SHOW_DETAILS';

interface UseShipmentActionArgs {
  shipment: Pick<ShipmentSummary, 'status' | 'direction_type'>;
  exclude?: ShipmentAction[];
}

function applyFilters(input: ShipmentAction[], exclude?: ShipmentAction[]): ShipmentAction[] {
  return exclude?.length ? input.filter(a => !exclude.includes(a)) : input;
}

export function useShipmentActions({
  shipment: { status, direction_type },
  exclude,
}: UseShipmentActionArgs): ShipmentAction[] {
  const actions: ShipmentAction[] = ['SHOW_DETAILS', 'DUPLICATE'];

  if (status === 'CANCELED') {
    return applyFilters(actions, exclude);
  }

  actions.push('CANCEL', 'CANCEL_AND_DUPLICATE');

  if (status === 'BOOKED' && direction_type === 'RETURN') {
    actions.push('FREIGHT_DOCUMENTS');
  }

  if (status === 'CREATED' || status === 'INVALID_BOOKING') {
    actions.push('BOOK', 'EDIT');
  }

  if (status === 'BOOKED') {
    actions.push('SCHEDULE_PICKUP');
  }

  if (status !== 'CREATED' && direction_type !== 'RETURN') {
    actions.push('CREATE_RETURN');
  }

  if (status !== 'CREATED') {
    actions.push('PRINT_LABEL');
  }

  return applyFilters(actions, exclude);
}
